import React, { ReactNode, ReactElement } from 'react';
import { createStyles } from '../../utils/css';
import MediaElement, { MediaType } from './MediaElement';
import { ExtractProps } from '../../utils/types';
import useVideoSize, { IVideoSize } from '../call/useVideoSize';

type OverriddenProps = 'playsInline' | 'className' | 'type';

interface IProps extends Omit<ExtractProps<typeof MediaElement>, OverriddenProps> {
  readonly children: (args: {
    video: ReactNode,
    width: number,
    height: number,
  }) => ReactElement<any> | null;
  onVideoSizeChange?: (size: IVideoSize) => void;
}


/**
 * It calls `children({ video, width, height })` which arguments are the
 * actual video element and the dimensions of the video signal frame
 * (not the element size), the equivalents of `videoWidth` and
 * `videoHeight`.
 */
const Video: React.FC<IProps> = ({ children, onVideoSizeChange, ...rest }) => {
  const [{ width, height }, videoSizeRef] = useVideoSize({ onVideoSizeChange });

  const video = <Styles>{(css) =>
    <MediaElement<MediaType.Video>
      type={MediaType.Video}
      getRef={videoSizeRef}
      className={css('video')}
      playsInline
      {...rest}
    />
  }</Styles>;

  return children({ video, width, height });
};

export default Video;

const Styles = createStyles({
  video: {
    display: 'block',
    width: '100%',
  },
});
